export default "__VITE_ASSET__BrZjO36Y__"